import React from "react";
import { notification } from "../../utils/Notifications.tsx";
import { saveDocumentType } from "../../services/documentTypes.service.ts";

interface NewDocumentTypeProps {
  closeFn: () => void;
}

const NewDocumentType: React.FC<NewDocumentTypeProps> = ({ closeFn }) => {
  const [name, setName] = React.useState("");
  const [obligatory, setObligatory] = React.useState(false);
  const [maxDayToUpload, setMaxDayToUpload] = React.useState<number>(0);
  const [saving, setSaving] = React.useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) {
      notification("Error", "El nombre es requerido", "danger");
      return;
    }
    const days = Math.min(30, Math.max(0, Number(maxDayToUpload) || 0));
    setSaving(true);
    try {
      await saveDocumentType({ name: name.trim(), obligatory, maxDayToUpload: days });
      notification("Éxito", "Tipo de documento creado correctamente", "success");
      closeFn();
    } catch (error: any) {
      notification(
        "Error",
        error?.message || "Error al guardar el tipo de documento",
        "danger"
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-3">
        <label className="form-label">Nombre</label>
        <input
          type="text"
          className="form-control"
          placeholder="Nombre del tipo de documento"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Días máximos para subir</label>
        <input
          type="number"
          min={0}
          max={30}
          className="form-control"
          placeholder="0"
          value={maxDayToUpload === 0 ? "" : maxDayToUpload}
          onChange={(e) => setMaxDayToUpload(e.target.value === "" ? 0 : parseInt(e.target.value, 10) || 0)}
        />
        <small className="text-muted">Entre 0 y 30 días</small>
      </div>
      <div className="mb-3 form-check">
        <input
          type="checkbox"
          className="form-check-input"
          id="obligatory-new"
          checked={obligatory}
          onChange={(e) => setObligatory(e.target.checked)}
        />
        <label className="form-check-label" htmlFor="obligatory-new">
          Obligatorio
        </label>
      </div>
      <div className="d-flex justify-content-end">
        <button type="button" className="btn btn-secondary me-2" onClick={closeFn}>
          Cancelar
        </button>
        <button type="submit" className="btn btn-success" disabled={saving}>
          {saving ? "Guardando..." : "Guardar"}
        </button>
      </div>
    </form>
  );
};

export default NewDocumentType;
